const config = {
    id: 17,
    name: "中部导航",
    type: 1,
    module_code: "middle_nav",
    icon: "icon-tms-middle_nav",
    font_icon: "&#xe628;",
    style_type: 1,
    link_type: 5,
    link_data: [{
            name: "菜单1"
        },
        {
            name: "菜单2"
        },
        {
            name: "菜单3"
        }
    ]
};

export default config